import { render, staticRenderFns } from "./zones_form.vue?vue&type=template&id=484132ef"
import script from "./zones_form.vue?vue&type=script&lang=js"
export * from "./zones_form.vue?vue&type=script&lang=js"
import style0 from "./zones_form.vue?vue&type=style&index=0&id=484132ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports